import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.js'
import fr from './fr.js';
import it from './it.js';
import de from './de.js';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      de: { translation: de }
    },
    lng: localStorage.getItem('lang') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
